import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { capitalizeFirstLetter, getLocalKey, getUserData, logOutCenter, setLocalKey } from '../../../utils/commonfunction';
import { Link, NavLink, useLocation, useParams } from 'react-router-dom';
import i18next from 'i18next';
// import { SOCKET_CLIENT } from '../../../utils/socket';
import { ROLE } from '../../../utils/Constants';
import logowide from '../../../assets/center/images/logo-h.png';
export default function Header() {
  const { t } = useTranslation();
  const [doctorUserData, setDoctorUserData] = useState({});
  const [flag, setFlag] = useState(getLocalKey("system_language_flag"));
  const location = useLocation();
  const params = useParams();

  const changeLanguage = (lang, flag) => {
    i18next.changeLanguage(lang);
    setLocalKey("system_language", lang);
    setLocalKey("system_language_flag", flag);
    setFlag(flag);
    const evt = new CustomEvent("language_change");
    document.dispatchEvent(evt);
  }

  useEffect(() => {
    const userData = getUserData(ROLE.DOCTOR);
    setDoctorUserData(userData)
  }, [])

  const isActive = (url = "/") => {
    return window?.location?.pathname?.includes(url);
  }
  // function testSocket() {
  //   let message = prompt("Enter message") || "Hello from socket";
  //   SOCKET_CLIENT.emit('testSocket', message, (error) => {
  //     if (error) {
  //       console.log("*****Socket connection error on notificationSend", error);
  //     }
  //   })
  // }
  // useMemo(() => {
  //   SOCKET_CLIENT.on('testSocketReply', async (response) => {
  //     console.log("Data", response);
  //   });
  //   SOCKET_CLIENT.on('GET-DATA', async (response) => {
  //     console.log("Data", response);
  //   });
  // }, []);
  const handleThemeChange = () => {
    const html = document.querySelector("html");
    if (html.classList.contains("dark-theme")) {
      html.classList.remove("dark-theme");
      setLocalKey("darktheme", "false");
    } else {
      html.classList.add("dark-theme");
      setLocalKey("darktheme", "true");
    }
  }

  const routeTitles = {
    "/doctor/dashboard/1": "Dashboard",
    "/doctor/profile": "My Profile",
    "/doctor/profile/change-password": "Change Password",
    "/doctor/settings/patient/1": "Patient Management",
    "/doctor/patient/appointment/1": "Appointment Management",
    "/doctor/consultation-history/1": "Consultation History",
    "/doctor/patient/appointment/view/${params?.id}": "Patient Management",
    "/doctor/patient/medical-history/view": "Medical History",
    "/doctor/consultation/prescription/add": "Create Prescription",
    "/doctor/consultation/prescription/edit/": "Update Prescription",
    "/doctor/consultation/medical-history/view": "Medical History",
    "/doctor/patient/appointment/view/:id": "Patient Management",
    "/doctor/consultation/prescription/view/:id" : "View Prescription",
    "/doctor/patient/diet-chart/add" : "Generate Diet Chart"
  };

  const getRouteTitle = (pathname) => {
    if (routeTitles[pathname]) return routeTitles[pathname];
    const matchedRoute = Object.keys(routeTitles).find(route =>
      route.includes(":id") && pathname.startsWith(route.replace(":id", ""))
    );
    return matchedRoute ? routeTitles[matchedRoute] : null;
  };

  const heading = getRouteTitle(location.pathname);
  return (
    <div className='header'>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <Link className="navbar-brand">
            <img src={logowide} />
          </Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <div className='page-heading-header me-auto'>
              <h1 className='m-0'>{heading}</h1>
            </div>
            <div className='d-flex gap-3 align-items-center bell-btn'>
              {/* <div className="btn btn-icon">
                <i className='ti ti-bell'></i>
              </div> */}
              <div className="dropdown profile-dropdown">
                <button className="dropdown-toggle flex-column" type="button" data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <div className='avatar avatar-sm'>
                    {console.log("profile_image", doctorUserData.profile_image)}
                    <img src={doctorUserData.profile_image} alt='profile-img' />
                  </div>
                  <span>{capitalizeFirstLetter(doctorUserData.name)}</span>
                  <i className='ti ti-chevron-down'></i>
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" onClick={(e) => {
                      e.preventDefault(); logOutCenter(ROLE.DOCTOR)
                    }}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 8V6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H12C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18V16M7 12H21M21 12L18 9M21 12L18 15" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>{t("center.header.label_logout")}</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>
  )
}